var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKetlonStudioLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.016 0H0.017334V40H15.016V0Z",
    fill: "#6CB645"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5167 20.0163L15.0051 0H0.017334L20.0228 32.0174L27.5167 20.0163Z",
    fill: "#00A1DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7657 22.0148L21.2718 34.0159L25.0079 39.9892H40.0065L28.7657 22.0148Z",
    fill: "#00A1DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.017334 39.9891H15.0051L40.0065 0H25.0078L0.017334 39.9891Z",
    fill: "#9ACA3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKetlonStudioLogo);
export default __webpack_public_path__ + "static/media/ketlon-studio-logo.332fc1997aa3adcc533c8815cc98e26c.svg";
export { ForwardRef as ReactComponent };